import React, { useEffect, useState } from "react";
import Heading from "../../Components/Heading/Heading";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import Develop from "../../Components/Develop/Develop";

function Beneficiaries() {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const onButtonClick = (url) => {
    // navigate(url);
  };

    // useEffect(() => {
    //   axios
    //     .get(`${process.env.REACT_APP_API_URL}/beneficiaries/`, { withCredentials: true })
    //     .then((res) => {
    //       setData(res.data);
    //     })
    //     .catch((error) => {
    //       toast.error(error?.message);
    //       console.log(error)
    //     });
    // }, []);

  return (
    <div>
      <Heading
        title="المستفيدون"
        button="إضافة مستفيد جديد"
        onButtonClick={() => onButtonClick("/app/beneficiaries/new")}
      />
      {data ? (
        <pre>{JSON.stringify(data, null, 2)}</pre>
      ) : (
        <Develop title={"الميزة قيد التطوير..."}/>
      )}
    </div>
  );
}

export default Beneficiaries;
